import { Directive, TemplateRef } from '@angular/core';

@Directive({selector: '[appQueryOperator]'})
export class QueryOperatorDirective {
  constructor(public template: TemplateRef<any>) {}
}
